import BaseService from '../BaseService'
import axios from "axios";

class CampaignService extends BaseService {
    constructor() {
        super('/campaigns');
    }

    statusUpdate({id, payload}) {
        return axios.put(`api/v1/campaign-status-update/${id}`, payload)
    }
}

export default new CampaignService()
